import Box from '@mui/system/Box';

import { PROPS } from './Block.utils';
import styles from './Block.styles';

export default function Block({ children, sx }: PROPS) {
  return <Box sx={{ ...styles.wrapper, ...sx }}>{children}</Box>;
}
